import clsx, { type ClassValue } from 'clsx';

/** Re-exported clsx as `cn` for ergonomic composition. */
export const cn = (...args: ClassValue[]) => clsx(...args);
